import classNames from 'classnames'
import styled from 'styled-components'
const LeftToolbar = styled.div`
display: flex;
align-items: center;
`
import { ReactNode } from 'react';

interface LeftToolBarProps {
  className?: string;
  children?: ReactNode;
}

const LeftToolBar = ({ className, ...props }: LeftToolBarProps) => {
   
    const toolbarClass = classNames("common__left_toolbar", className);
  return (
    <LeftToolbar className={toolbarClass}>
      {props.children}
    </LeftToolbar>
  )
}

export default LeftToolBar
